// extracted by mini-css-extract-plugin
module.exports = {"map":"styles_map__zFk5i","card":"styles_card__R5yxm","address":"styles_address__oPGYS"};